export const dropdownResponse = {
  data: {
    eventId:
      '2f003cca-798e-d1c6-41da-dc42522a0fe9----8a7901fe-22fc-de8d-4d38-a0e852e01b4b',
    eventType: 'GET_HS_MASTER_HS',
    eventMessage: {
      hsMasterReq: {
        country: '',
        hsVersion: '',
        itemType: '',
        firmDesc: ''
      },
      itemList: [
        {
          id: 'NONE',
          description: 'NONE',
          ediCode: 'NONE'
        }
      ],
      header: {
        code: 200
      }
    },
    eventTime: 1559660126190
  }
}
